var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslateWithoutHovering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.98,
    height: 14.298,
    viewBox: "0 0 14.98 14.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14736",
    "data-name": "Group 14736",
    transform: "translate(0.229 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14737",
    "data-name": "Group 14737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11196",
    "data-name": "Path 11196",
    d: "M233.878,194.89h-8.445a.141.141,0,0,0-.143.143V203.5a.141.141,0,0,0,.143.143h8.445a.141.141,0,0,0,.143-.143v-8.463a.14.14,0,0,0-.143-.143m-4.959,6.638-2.364-2.364.693-.693,1.671,1.671L232.062,197l.693.693Z",
    transform: "translate(-219.269 -189.59)",
    fill: "var(--mainColor)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11197",
    "data-name": "Path 11197",
    d: "M352.224,7.774h2.744a1.213,1.213,0,0,1,1.212,1.211V10.34h.57l-.463.873-.463.855-.463-.855-.481-.873h.57V8.986a.479.479,0,0,0-.481-.481h-2.744V7.774Z",
    transform: "translate(-342.732 -7.565)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11198",
    "data-name": "Path 11198",
    d: "M22.656,350.6H19.485a1.228,1.228,0,0,1-1.229-1.211v-1.354h-.57l.481-.873.463-.873.927,1.746H19v1.354a.479.479,0,0,0,.481.481h3.172v.731Z",
    transform: "translate(-17.208 -336.957)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11199",
    "data-name": "Path 11199",
    d: "M8.773.635V5.016H6.3a.55.55,0,0,0-.556.556v3.2H.652A.151.151,0,0,1,.5,8.621V.635A.149.149,0,0,1,.652.5H8.638A.145.145,0,0,1,8.773.635Z",
    transform: "translate(-0.479 -0.5)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11200",
    "data-name": "Path 11200",
    d: "M76.028,42.615v1.011h-.4a5.112,5.112,0,0,1-1.084,2.448q-.162.217-.349.436l.346.346v1.177a6.044,6.044,0,0,1-.989-.843,13.415,13.415,0,0,1-1.217,1.031c-.327.245-.556.393-.6.421l-.074.055-.5-.79.073-.037a13.478,13.478,0,0,0,1.1-.829c.206-.173.427-.37.647-.586a8.55,8.55,0,0,1-.647-1.155,9.637,9.637,0,0,1-.473-1.233l-.018-.092.492-.13.409-.108.018.092a7.739,7.739,0,0,0,.863,1.929,5.119,5.119,0,0,0,.919-1.538,3.022,3.022,0,0,0,.147-.593H70.939V42.615H73v-.551h.974v.551Z",
    transform: "translate(-69.326 -41.243)",
    fill: "var(--mainColor)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateWithoutHovering);
export default __webpack_public_path__ + "static/media/translateWithoutHovering.3432cf5462cec16506bdf98bf2c0fc1b.svg";
export { ForwardRef as ReactComponent };